import { createPortal } from '@/features/common/contexts/Portal'

export const { Provider, usePortal } = createPortal()
